import { useNavigate, useParams } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MobileShell from "./MobileShell";
import ServiceVaccine from "../pages/service/service";
import ServiceMicrochip from "../pages/service/service_microchip";
import ServiceParasite from "../pages/service/service_parasite";
import { clearMobileSession } from "./session";

export default function MobileServicePage() {
  const navigate = useNavigate();
  const { type } = useParams();
  const serviceMap = {
    microchip: {
      title: "Microchip",
      Component: ServiceMicrochip,
    },
    parasite: {
      title: "ปรสิต",
      Component: ServiceParasite,
    },
    vaccine: {
      title: "วัคซีน",
      Component: ServiceVaccine,
    },
  };
  const { title, Component: ServiceComponent } =
    serviceMap[type] || serviceMap.vaccine;

  const logout = () => {
    clearMobileSession();
    navigate("/mobile/login", { replace: true });
  };

  return (
    <MobileShell title={title} onLogout={logout}>
      <Box sx={{ px: 1.5, pt: 1 }}>
        <IconButton onClick={() => navigate("/mobile")} aria-label="back">
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          px: 0,
          pb: 4,
          "& .MuiBreadcrumbs-root": { display: "none" },
          "& .MuiPaper-root": { borderRadius: 2, boxShadow: "none" },
          "& .MuiContainer-root": { px: 1 },
        }}
      >
        <ServiceComponent />
      </Box>
    </MobileShell>
  );
}
